<template>
  <ul class="edit-list">
    <slot/>
  </ul>
</template>

<script>
import {ContainerMixin} from "vue-slicksort";

export default {
  name: "sortable-list",
  mixins: [ContainerMixin],
}
</script>